import { useMutation, useQueryClient } from "@tanstack/react-query"
import toast from "react-hot-toast";
import { addProductPrice } from "services/apiProductPricing";

const useAddProductPrice = () => {
  
    const queryClient = useQueryClient();
    const{isPending:isAdding,isSuccess:isAdded,mutate: addPrice} = useMutation({
        mutationFn: addProductPrice,
        onSuccess:(data)=>{
            queryClient.setQueryData(['newPrice'],data)
            queryClient.invalidateQueries({queryKey:['priceList']})
            toast.success("Price added Successfully")
        },
        onError:(error)=>{
            console.log("Error occurred while adding products",error)
            if(error?.data && typeof error.data === "object"){
                for (const key in error.data){
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg)
                }
            }else{
                toast.error(error.message || 'Something went wrong')
            }
        
        }
    })

    return {isAdding,isAdded,addPrice}
}

export default useAddProductPrice
